import React from 'react'
import classNames from 'classnames'
import { WemoloClockIcon, WemoloImageIcon, WemoloLicensePlateIcon, WemoloListIcon } from '../../../components/Wemolo'
import { ViewMode } from '../DetectionExplorerStore'
import { DETECTION_EXPLORER_TEXT } from '../config'
import { AddFilterContainer } from './AddFilter'
import { ActiveFiltersContainer } from './ActiveFilters'
import { TimeFrameUI, TimeFrameUIProps } from './TimeFrame'
import styles from './Filters.module.css'

export type FiltersUIProps = TimeFrameUIProps & {
    viewMode: ViewMode
    onViewModeChange: (mode: ViewMode) => void
    showImageRequests: boolean
    imageRequestsOpen: boolean
    onToggleImageRequests: () => void
}

export const FiltersUI: React.FC<FiltersUIProps> = ({
    startValue,
    endValue,
    minDateTime,
    maxDateTime,
    onStartChange,
    onEndChange,
    preset,
    onPresetChange,
    viewMode,
    onViewModeChange,
    showImageRequests,
    imageRequestsOpen,
    onToggleImageRequests
}) => (
    <div className={styles.filters}>
        <div className={styles.left}>
            <TimeFrameUI
                startValue={startValue}
                endValue={endValue}
                minDateTime={minDateTime}
                maxDateTime={maxDateTime}
                onStartChange={onStartChange}
                onEndChange={onEndChange}
                preset={preset}
                onPresetChange={onPresetChange}
            />
            <ActiveFiltersContainer />
            <AddFilterContainer />
        </div>

        <div className={styles.right}>
            <div
                className={styles.viewToggleGroup}
                role="group"
                aria-label={DETECTION_EXPLORER_TEXT.filters.viewModeGroup}
            >
                {showImageRequests && (
                    <>
                        <button
                            type="button"
                            aria-label={DETECTION_EXPLORER_TEXT.imageRequests.title}
                            title={DETECTION_EXPLORER_TEXT.imageRequests.title}
                            aria-pressed={imageRequestsOpen}
                            className={classNames(styles.viewToggleButton, {
                                [styles.viewToggleButtonActive]: imageRequestsOpen
                            })}
                            onClick={onToggleImageRequests}
                        >
                            <WemoloClockIcon />
                        </button>
                        <span className={styles.viewToggleDivider} aria-hidden="true" />
                    </>
                )}
                <button
                    type="button"
                    aria-label={DETECTION_EXPLORER_TEXT.filters.groupByPlateView}
                    aria-pressed={viewMode === ViewMode.GroupByLPView}
                    className={classNames(styles.viewToggleButton, {
                        [styles.viewToggleButtonActive]: viewMode === ViewMode.GroupByLPView
                    })}
                    onClick={() => onViewModeChange(ViewMode.GroupByLPView)}
                >
                    <WemoloLicensePlateIcon />
                </button>
                <button
                    type="button"
                    aria-label={DETECTION_EXPLORER_TEXT.filters.galleryView}
                    aria-pressed={viewMode === ViewMode.GalleryView}
                    className={classNames(styles.viewToggleButton, {
                        [styles.viewToggleButtonActive]: viewMode === ViewMode.GalleryView
                    })}
                    onClick={() => onViewModeChange(ViewMode.GalleryView)}
                >
                    <WemoloImageIcon />
                </button>
                <button
                    type="button"
                    aria-label={DETECTION_EXPLORER_TEXT.filters.listView}
                    aria-pressed={viewMode === ViewMode.ListView}
                    className={classNames(styles.viewToggleButton, {
                        [styles.viewToggleButtonActive]: viewMode === ViewMode.ListView
                    })}
                    onClick={() => onViewModeChange(ViewMode.ListView)}
                >
                    <WemoloListIcon />
                </button>
            </div>
            {/* Settings button — hidden for now, action not yet defined.
            <button type="button" aria-label="Settings" onClick={onSettingsClick} className={styles.settingsButton}>
                <WemoloSettingsIcon />
            </button>
            */}
        </div>
    </div>
)
